var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveFromJob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.1543 7C7.81114 7 9.1543 5.65685 9.1543 4C9.1543 2.34315 7.81114 1 6.1543 1C4.49744 1 3.1543 2.34315 3.1543 4C3.1543 5.65685 4.49744 7 6.1543 7Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 13.0008C1 10.6788 3.31 8.80078 6.15399 8.80078C6.72999 8.80078 7.28799 8.87878 7.80999 9.02278",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1545 10.5992C12.1545 10.7912 12.1305 10.9772 12.0825 11.1572C12.0285 11.3972 11.9325 11.6312 11.8065 11.8352C11.3925 12.5312 10.6305 12.9992 9.75449 12.9992C9.13649 12.9992 8.57849 12.7652 8.15849 12.3812C7.97849 12.2252 7.82249 12.0392 7.70249 11.8352C7.48049 11.4752 7.35449 11.0492 7.35449 10.5992C7.35449 9.95122 7.61249 9.35722 8.03249 8.92522C8.47049 8.47522 9.08249 8.19922 9.75449 8.19922C10.4625 8.19922 11.1045 8.50522 11.5365 8.99722C11.9205 9.42322 12.1545 9.98722 12.1545 10.5992Z",
    stroke: "#5B6B79",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3715 9.96484L9.10547 11.2308",
    stroke: "#5B6B79",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.11816 9.97656L10.3902 11.2425",
    stroke: "#5B6B79",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromJob);
export default __webpack_public_path__ + "static/media/remove_from_job.b1b05f6eac3b56fca43e49e361272ecb.svg";
export { ForwardRef as ReactComponent };